module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "move"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show),
      expression: "show"
    }],
    class: _vm.toastClass
  }, [_c('i', {
    class: _vm.iconClass
  }, [_c('svg', {
    attrs: {
      "viewBox": "64 64 896 896",
      "data-icon": "check-circle",
      "width": "1em",
      "height": "1em",
      "fill": "currentColor",
      "aria-hidden": "true"
    }
  }, [_c('path', {
    attrs: {
      "d": _vm.icon[_vm.type]
    }
  })])]), _vm._v(" "), _c('span', {
    staticClass: "wps-toast-text"
  }, [_vm._v(_vm._s(_vm.message))])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1e6109f8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./app/plugins/toast/Toast.vue
// module id = 98
// module chunks = 1